import { useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import SearchBar from "components/base/SearchBar";
import { InlineSpinner } from "components/base/Spinner";
import { useModals } from "ModalProvider";
import moment from "moment";
import { useSearchParams } from "react-router-dom";
import { FETCH_FSI_ORDERS } from "./graphql";
import OrderDetail from "./OrderDetail";

const PAGE_SIZE = 30;

const FSIOrders = () => {
  const [searchParams, setSearchParams] = useSearchParams({ offset: 0, q: "" });
  const q = searchParams.get("q");
  const offset = parseInt(searchParams.get("offset")) || 0;
  const { loading, error, data } = useQuery(FETCH_FSI_ORDERS, {
    variables: { offset, q },
  });
  const modal = useModals();
  const isNew = (createdAt) =>
    moment.duration(moment().diff(moment(createdAt))).asDays() < 1;

  return (
    <div className="card flex-1 overflow-auto mt-0 m-6 p-0 flex flex-col">
      <div className="flex-1">
        <table>
          <thead>
            <tr className="whitespace-nowrap sticky top-0 z-10 bg-gray-50">
              <th className="px-4">
                <div className="flex items-center space-x-2">
                  <div>Order</div>
                  <div className="flex-1">
                    <SearchBar
                      className="bg-gray-100"
                      placeholder="Search by order number"
                      onChange={(q) => setSearchParams({ q, offset: 0 })}
                    />
                  </div>
                </div>
              </th>
              <th className="text-right">Created At</th>
              <th className="text-right px-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={3}>
                  <InlineSpinner />
                </td>
              </tr>
            ) : error ? (
              <tr>
                <td colSpan={3}>
                  <Errors error={error} />
                </td>
              </tr>
            ) : (
              data.fsiOrders.results.map((order, index) => (
                <tr
                  key={index}
                  className="border-b border-gray-100 dark:border-gray-700"
                >
                  <td className="px-4">
                    <div className="flex items-center space-x-2">
                      <Button
                        disabled={!order.orderId}
                        onClick={() =>
                          modal.present({
                            title: "FSI Order Detail",
                            hideChildren: true,
                            center: true,
                            children: <OrderDetail id={order.orderId} />,
                          })
                        }
                      >
                        {order.orderNumber}
                      </Button>

                      {isNew(order.createdAt) ? (
                        <div className="text-xs bg-green-500 text-white px-2 py-0.5 rounded-full leading-tight">
                          New
                        </div>
                      ) : null}
                    </div>
                  </td>
                  <td className="text-right whitespace-nowrap">
                    {moment(order.createdAt).format("YYYY-MM-DD hh:mm:ss")}
                  </td>
                  <td className="text-right whitespace-nowrap px-4">
                    <div className="flex justify-end items-center space-x-2">
                      <div
                        className={`font-semibold text-xs
                         ${order.status === "success" ? " text-green-600" : " text-red-600"}
                         `}
                      >
                        {order.status}
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {data ? (
        <div className="flex justify-end items-center space-x-2 sticky bottom-0 bg-gray-50 px-4 py-3 z-20">
          {offset > 0 ? (
            <Button
              prev
              onClick={() => setSearchParams({ offset: offset - PAGE_SIZE, q })}
            />
          ) : null}
          <div>
            {offset + 1}-{Math.min(PAGE_SIZE + offset, data.fsiOrders.total)} /{" "}
            {data.fsiOrders.total}
          </div>
          {data.fsiOrders.total > offset + PAGE_SIZE ? (
            <Button
              next
              onClick={() => setSearchParams({ offset: PAGE_SIZE + offset, q })}
            />
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default FSIOrders;
